import headshot from './images/headshot.jpg';
import l3harris_logo from "./images/L3Harris_Technologies_logo.svg";
import sap_logo from "./images/SAP_logo.svg";
import okta_logo from "./images/Okta_logo.svg";
import temple_logo from "./images/temple_logo.svg";
import central_logo from './images/central_logo.png';
import { SocialIcon } from 'react-social-icons';

export default function Home() {
    return (
    <div>
        <div className='container'>
            <div>
                <p></p>
                <p>Hi, I'm Brian. I'm a senior software engineer based in Rochester, New York, with experience building embedded, real-time, and enterprise software systems.</p>
                <p>My current work focuses on C++ embedded development for timing-critical radio systems, including low-latency control software, hardware/software interfaces, and automated test infrastructure. Earlier in my career, I worked on enterprise identity and cloud platforms, building integration prototypes, backend services, and automation for large-scale customer environments.</p>
                <p>I earned a B.S. in Computer Science and Mathematics from Temple University, with a minor in Data Science. My technical interests include embedded systems, C/C++, real-time software, RF communications, systems programming, and applied machine learning.</p>
                <p>Outside of work, I enjoy experimenting with new technologies, building personal projects, hiking, and gaming. I try to approach both engineering and personal development with the same mindset: keep learning, measure what matters, and continuously improve.</p>
                <p>If you'd like to connect, feel free to get in touch.</p>
            </div>
            <div>
                <img className='circular_image' src={headshot} alt='profile' />
                <div className='container'>
                    <SocialIcon url="mailto:brian@bri-davis.com" />
                    <SocialIcon url="https://linkedin.com/in/bri-davis" />
                    <SocialIcon url="https://www.github.com/bri-davis" />
                </div>
            </div>
        </div>
        <div className='container'>
            <p>Experience</p>
        </div>
        <div className='container'>
            <img className='company_logo work_logo' src={l3harris_logo} alt='L3Harris Technologies' />
            <img className='company_logo work_logo' src={okta_logo} alt='Okta' />
            <img className='company_logo work_logo' src={sap_logo} alt='SAP' />
        </div>
        <div className='container'>
            <p>Education</p>
        </div>
        <div className='container'>
            <img className='company_logo' src={temple_logo} alt='logo' />
            <img className='company_logo' src={central_logo} alt='logo' />
        </div>
    </div>
    )
  }
